// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
const newUserTooltipActions = require('client-v2/common/containers/tooltips/actions/new-user')
// Entry imports
const configureStore = require('./state/store')
const rootFactory = require('./components/root').factory
const collectionEditModalActions = require('./containers/collection-edit-modal/actions')
const { showArticleProfileModal } = require('./containers/feed/actions')

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  const initialState = store.getState()

  const businessEventsPageActions = {
    'collection-profile.showPosts': 'posts',
    'collection-profile.showSubscribers': 'followers'
  }
  const pageAction = businessEventsPageActions[initialState.router.action]
  commonClient.configureSession(store, {
    pageName: `mix.${pageAction}`,
    streamId: initialState.collection.id,
    streamType: 'mix'
  })

  businessEvents.trackProtobuf('TrackMixProfileView', {
    userId: initialState.user.id,
    viewedMixId: initialState.collection.id
  })
  businessEvents.trackSegment('pageview')

  store.dispatch(newUserTooltipActions.showCollectionProfileSubscribeTooltip())

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })

  // Show article-profile modal for `modal=1` query parameter
  if (pageAction === 'posts' && queryParams.modal) {
    store.dispatch(showArticleProfileModal({ urlId: queryParams['url_id'] }))
  }

  // Show edit collection modal for `edit=1` query parameter
  if (
    queryParams.edit &&
    initialState.collection['user_id'] === initialState.user.id
  ) {
    store.dispatch(collectionEditModalActions.show())
  }

})
